export default "__VITE_ASSET__fmRXki62__"